import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';

import { FormBuilder, FormGroup } from '@angular/forms';
import { DspaceStatisticsService } from '../../services/dspace-statistics-service';
import { AddDspaceStatisticsComponent } from '../add-dspace-statistics/add-dspace-statistics.component';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-dspace-statistics',
  templateUrl: './get-dspace-statistics.component.html',
  styleUrls: ['./get-dspace-statistics.component.scss'],
})
export class GetDspaceStatisticsComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: DspaceStatisticsService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService
  ) {
    super(route, service, null, '', diag);
  }

  ngOnInit() {
    this.loadEntities();
  }

  addNew() {
    this.dialog
      .open(AddDspaceStatisticsComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddDspaceStatisticsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
